import React from "react";
import { Link } from "react-router-dom";
import Loading from "../components/Loading";

function Blogs({ blogs, loading }) {
  if (loading === true) {
    return <Loading />;
  } else
    return (
      <>
        <div id="container">
          <div className="max-w-[1440px] flex flex-col lg:p-4 p-2 mt-24 justify-center">
            <div className="grid gap-y-10 md:grid-cols-2 lg:gap-10 lg:grid-cols-4">
              {blogs.map((item) => (
                <div
                  key={item.id}
                  className="max-w-sm bg-slate-800 rounded-lg overflow-hidden shadow-lg border-2 border-blue-500 shadow-blue-900"
                >
                  <img
                    className="w-full h-52 object-cover"
                    src={item.data.img}
                    alt=""
                  />
                  <div className="flex flex-col p-3 space-y-4">
                    <Link className="truncate" to={`/blogs/${item.id}`}>
                      <strong>{item.data.title}</strong>
                    </Link>
                    <small>
                      {new Date(
                        item.data.created.seconds * 1000
                      ).toLocaleDateString("en-US")}
                    </small>
                    <small className="truncate">{item.data.para}</small>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </>
    );
}

export default Blogs;
